import { render, staticRenderFns } from "./car-preview-modal.vue?vue&type=template&id=2c8b630a&scoped=true"
import script from "./car-preview-modal.vue?vue&type=script&lang=js"
export * from "./car-preview-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8b630a",
  null
  
)

export default component.exports